import { render, staticRenderFns } from "./StaticInvoiceFetcher.vue?vue&type=template&id=d55467f2&scoped=true&"
import script from "./StaticInvoiceFetcher.vue?vue&type=script&lang=js&"
export * from "./StaticInvoiceFetcher.vue?vue&type=script&lang=js&"
import style0 from "./StaticInvoiceFetcher.vue?vue&type=style&index=0&id=d55467f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55467f2",
  null
  
)

export default component.exports